import api from "./api";

export const teamService = {
  getAll: () => api.get("/team").then((res) => res.data),
  getById: (id) => api.get(`/team/${id}`).then((res) => res.data),
  create: (data) => api.post("/team", data).then((res) => res.data),
  update: (id, data) => api.put(`/team/${id}`, data).then((res) => res.data),
  delete: (id) => api.delete(`/team/${id}`).then((res) => res.data),
};
